import { Button } from "@mui/material";
import styles from './Buttons.module.scss';

interface Props {
    id: string;
    label: string;
    onclickHandler: any;
    disabled?: boolean;
    customStyle?: any;
}

export default function NormalButton ({id, label, onclickHandler, disabled, customStyle}: Props){
    return (
        <Button
            style={customStyle}
            disabled={disabled}
            size="small"
            id={id}
            className={[styles.btn, styles.normalButton].join(" ")}
            onClick={onclickHandler}
            variant="contained"
        >
            {label}
        </Button>
    );
}